import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  alertMessage: string = '';
  messages: any = [];

  add(source: string, message: string) {
    this.alertMessage = '';

    if (
      this.messages.filter((val: any) => val['source'].includes(source)).length
    ) {
      this.messages = this.messages.filter(
        (val: any) => !val['source'].includes(source)
      );
    }

    setTimeout(() => {
      this.alertMessage = message;
      this.messages.unshift({ source: source, message: message });
    }, 800);
  }

  remove() {
    this.messages.splice(0, 1);
    this.alertMessage = '';
    if (this.messages.length) {
      setTimeout(() => {
        this.alertMessage = this.messages[0].message;
      }, 800);
    }
  }

  clear() {
    this.messages = [];
    this.alertMessage = '';
  }
}
